import {
  CircularProgress,
  Grid,
  IconButton,
  Typography
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import PropTypes from 'prop-types';
const Count = ({ ...props }) => {

  return (
    <Grid {...props}
      container
    >
      <Grid item container
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          position: 'relative'
        }}
        sx={{
          bgcolor: props.status.darkColor,
          borderRadius: '15px 15px 0px 0px',
        }}>
        <Typography
          color="textSecondary"
          sx={{
            mb: 0.5,
            mt: 1,
            fontWeight: 500
          }}
          variant="caption"
        >
          {props.status.status}
        </Typography>
      </Grid>
      <Grid item container sx={{
        minHeight: '50px',
        bgcolor: props.status.bgColor + '99',
        borderRadius: '0px 0px 15px 15px',
        border: '1px solid rgba(224, 224, 224, 1)'
      }}
        alignItems="center" justifyContent="center">
        <Typography
          color="textSecondary"
          variant="h4"
        >
          {
            (props.loading && props.server) ?
              (<div className="p-r-15 pull-right m-t-10"><div className="dot-flashing"></div></div>) : 
              <span className={props.status.totalCount == 0 ? 'gray-color' : "secondary-color"}>{props.status.totalCount ? props.status.totalCount : 'NA'}</span>
          }
          {
            ( !props.loading && !props.server) && 
              <IconButton onClick={() => props.refresh()} size="small">
                <Refresh color="primary"/>
              </IconButton>
          }
        </Typography>
      </Grid>
    </Grid>
  );
}

// StatusCount.propTypes = {
//   settingStatus: PropTypes.func,
//   statusSelected: PropTypes.string
// }

export default Count;
